import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FundraiserHeader from "../common/FundraiserHeader";
import FundraiserBodyHeader from "../common/FundraiserBodyHeader";
import RelatedSubscriptionsHeader from "../common/RelatedSubscriptionsHeader";
import SubscriptionPlan from "../common/SubscriptionPlan";
import ExistingSubscriptionPlan from "../common/ExistingSubscriptionPlan";
import {
  cancelSubscription,
  getUserSubscription,
  renewSubscription,
  renewSubscriptionFromReminder,
  upgradeSubscription,
} from "../../../services/subscriptionService";
import CancelSubscriptionPopup from "../../common/CancelPopup.jsx";
import toast from "../../../utils/toast.js";
import { setSelectedPlan } from "../../../redux/slices/subscriptionSlice.js";
import cancelImage from "../../../Assets/Images/cancelImage.svg";

const ExistingSubscription = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const allPlans = useSelector(
    (state) => state?.subscriptionReducer?.subscriptionPlans
  );
  const activeSubscription = useSelector(
    (state) => state?.subscriptionReducer?.subscription
  );
  const subscriptionId = useSelector(
    (state) => state?.subscriptionReducer?.subscription?.subscriptionId
  );
  const [cancelClicked, setCancelClicked] = useState(false);
  const [yearlyPlan, setYearlyPlan] = useState({});
  const [subscriptionCancelled, setSubscriptionCancelled] = useState(false);
  const canRenewToday = activeSubscription?.canRenewToday === true;

  useEffect(() => {
    if (allPlans !== null && Array.isArray(allPlans)) {
      // Find the yearly plan (same logic as SubscriptionDetails)
      const pickYearly = allPlans.find((p)=> String(p?.duration||"").toLowerCase().includes("year")) || 
                        allPlans.find((p)=> String(p?.duration||"").includes("12")) || 
                        allPlans.find((p)=> String(p?.name||"").toLowerCase().includes("premium")) ||
                        allPlans.find((p)=> String(p?.name||"").toLowerCase().includes("year")) ||
                        allPlans[0];
      setYearlyPlan(pickYearly);
    }
  }, [allPlans]);

  // Reset cancelled state when there's an active subscription
  useEffect(() => {
    if (activeSubscription) {
      setSubscriptionCancelled(false);
    }
  }, [activeSubscription]);

  const cancelClick = () => {
    setCancelClicked(true);
  };

  const handleKeepPlan = () => {
    setCancelClicked(false);
  };

  const handleCancelSub = async () => {
    setCancelClicked(false);
    const cancelPromise = await dispatch(
      cancelSubscription({ subscriptionId: subscriptionId })
    ).unwrap();
    if (cancelPromise?.success === true) {
      setSubscriptionCancelled(true);
      dispatch(getUserSubscription());
    }
  };

  // const joinClick = async (plan) => {
  //   // Check if this is an upgrade or downgrade
  //   const currentAmount = activeSubscription?.amount || 0;
  //   const newAmount = plan?.amount || 0;
    
  //   if (newAmount === currentAmount) {
  //     toast.info("You are already on this plan!");
  //     return;
  //   }
    
  //   try {
  //     dispatch(setSelectedPlan(plan));
      
  //     // Use upgrade endpoint instead of creating new subscription
  //     const upgradePayload = {
  //       subscriptionId: activeSubscription?.subscriptionId,
  //       newPriceId: plan?.priceId,
  //       currentPriceId: activeSubscription?.priceId,
  //     };
      
  //     const upgradeResult = await dispatch(upgradeSubscription(upgradePayload)).unwrap();
      
  //     if (upgradeResult?.success === true) {
  //       if (upgradeResult?.data?.url) {
  //         // Redirect to Stripe checkout for upgrade
  //         window.location.href = upgradeResult.data.url;
  //       } else {
  //         // Immediate upgrade without payment (e.g., downgrade)
  //         toast.success("Subscription updated successfully!");
  //         dispatch(getUserSubscription());
  //       }
  //     } else {
  //       // Fallback to regular subscription flow
  //       navigate("/fundraiser-subscription?upgrade=true");
  //     }
  //   } catch (error) {
  //     console.error("Upgrade failed:", error);
  //     // Fallback to regular subscription flow
  //     navigate("/fundraiser-subscription?upgrade=true");
  //   }
  // };
  const joinClick = async (plan) => {
    try {
      const renewPayload = { priceId: plan?.priceId };
      const renewResult = await dispatch(renewSubscription(renewPayload)).unwrap();

      if (renewResult?.success && renewResult?.data?.url) {
        window.location.href = renewResult.data.url;
      } else {
        toast.success("Subscription renewed successfully!");
        setSubscriptionCancelled(false);
        dispatch(getUserSubscription());
      }
    } catch (error) {
      console.error("Renewal failed:", error);
      toast.error("Something went wrong during renewal.");
    }
  };

  const handleReminderRenewal = async () => {
    try {
      const renewPayload = { priceId: yearlyPlan?.priceId || activeSubscription?.priceId };
      const renewResult = await dispatch(
        renewSubscriptionFromReminder(renewPayload)
      ).unwrap();

      if (renewResult?.success && renewResult?.data?.url) {
        window.location.href = renewResult.data.url;
        return;
      }

      dispatch(getUserSubscription());
    } catch (error) {
      console.error("Expiry-day renewal failed:", error);
      toast.error("Unable to start renewal right now.");
    }
  };


  return (
    <div className="w-full h-full">
      <FundraiserHeader />
      {cancelClicked === true ? (
        <CancelSubscriptionPopup
          handleNo={handleKeepPlan}
          handleYes={handleCancelSub}
          heading={"Cancel Subscription"}
          content={"Are you sure you want to cancel subscription?"}
          image={cancelImage}
        />
      ) : null}
      {activeSubscription ? (
        <>
          <div className="flex flex-col items-center pt-10 sm:py-10">
            <FundraiserBodyHeader
              heading={"Your Active Subscription"}
              content={""}
              contentClass={
                "w-[100%] sm:w-[80%] md:w-[90%] text-[#8C8C8C] mb-4"
              }
            />
            <ExistingSubscriptionPlan
              title="CURRENT PLAN"
              plans={activeSubscription?.description?.split(",")}
              price={activeSubscription?.amount}
              duration={new Date(
                activeSubscription?.subscriptionExpiryTime
              ).toLocaleDateString("en-US")}
              cancelClick={cancelClick}
              activeActionLabel={canRenewToday ? "Renew Now" : "Cancel Subscription"}
              activeActionClick={canRenewToday ? handleReminderRenewal : cancelClick}
              activeActionVariant={canRenewToday ? "primary" : "outline"}
            />
          </div>
          <div className="flex justify-center items-center sm:hidden pb-10">
            <SubscriptionPlan
              title="CURRENT PLAN"
              plans={activeSubscription?.description?.split(",")}
              price={activeSubscription?.amount}
              duration={new Date(
                activeSubscription?.subscriptionExpiryTime
              ).toLocaleDateString("en-US")}
              cancelOption={true}
              cancelClick={cancelClick}
              activeActionLabel={canRenewToday ? "Renew Now" : "Cancel Subscription"}
              activeActionClick={canRenewToday ? handleReminderRenewal : cancelClick}
              activeActionVariant={canRenewToday ? "primary" : "outline"}
            />
          </div>
        </>
      ) : null}
      {subscriptionCancelled && (
        <div className="bg-[#F4F4F4] py-10 flex flex-col items-center gap-12">
          <RelatedSubscriptionsHeader
            heading={"Related Subscription Plans"}
            content={
              "Select a Swoodle Membership and contribute 20% of the proceeds to foundation!"
            }
            contentClass={"w-[100%] sm:w-[80%] md:w-[90%] text-[#8C8C8C] mt-4"}
          />
          <div className="flex flex-col sm:flex-row w-full items-center justify-center gap-5">
            <SubscriptionPlan
              title={yearlyPlan?.name}
              plans={yearlyPlan?.description?.split(",")}
              price={yearlyPlan?.amount}
              duration={yearlyPlan?.duration}
              joinClick={() => joinClick(yearlyPlan)}
            />
          </div>
          <p className="text-[14px] sm:text-[16px] md:text-[18px] font-poppins font-[400] mt-4 text-center w-[90%]">
            By selecting a plan, you agree to our
            <span className="text-[#00ADEF] cursor-pointer" onClick={() => window.open("/privacy/toc", "_blank")}> Terms of Services </span>
            and
            <span className="text-[#00ADEF] cursor-pointer" onClick={() => window.open("/privacy/policy", "_blank")}> Privacy Policy</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default ExistingSubscription;
